import { Component } from '@angular/core';
import { ANGULAR_MODULES, OperationsComponent, SYNCFUSION_MODULES, TopBarComponent } from 'src/app/Shared/shared-imports';
import { VendorSettingService } from '../../../../services/VendorSetting.service';
import { ProductService } from '../../../../services/Product.service';
import { GeneralService } from 'src/app/services/general.service';
import { VendorService } from '../../../../services/Vendor.service';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Subscription, filter } from 'rxjs';
import '@angular/localize/init';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { SharedHTMLSettingsDataService } from 'src/app/Shared/sharedHTMLSettingsData.service';
import { VendorSearchComponent } from 'src/app/Shared/vendor-search/vendor-search.component';
import { WordReplacePipe } from 'src/app/Shared/word-replace.pipe';
import { EActionTypes, EToaster, EUserSecurityFunctionID } from "src/app/Shared/enum";
import { IUserPermissionHandler } from "src/app/Shared/model/CommonModel";
import { UserPermissionHandlerDirective } from "src/app/Shared/userPermissionHandler.directive";
import { LoaderComponent } from 'src/app/Shared/loader/loader.component';
import { take } from 'rxjs';
declare var bootstrap: any;

@Component({
  selector: 'app-ops-vendor-settings',
  imports: [SYNCFUSION_MODULES, ANGULAR_MODULES, OperationsComponent, TopBarComponent, VendorSearchComponent, WordReplacePipe,UserPermissionHandlerDirective, LoaderComponent],
  standalone: true,
  templateUrl: './ops-vendor-settings.html',
  styleUrl: './ops-vendor-settings.scss'
})
export class OpsVendorSettingsMaintenance {
  isCollapsed = true;
  vendorSettingForm: FormGroup;
  marketId;
  public loaderIcon: Promise<boolean> = Promise.resolve(false);
  vendorNamingConventions = [];
  vendorCasingCoventions = [];
  private subscriptions: Subscription[] = [];
  marketProductList = [];
  marketProductSelectedList = [];
  rentalSettings: any;

  handleToggle(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  viewPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.VendorSettings, Action: EActionTypes.VIEW };
  editPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.VendorSettings, Action: EActionTypes.EDIT };

  constructor(private formBuilder: FormBuilder, private vendorSettingService: VendorSettingService,
    private productService: ProductService, private generalService: GeneralService,
    private toastr: ToastrService, private router: Router,
    private sharedHTMLSettings: SharedHTMLSettingsDataService,
    private vendorService: VendorService,
    private wordReplacePipe: WordReplacePipe) {

    this.vendorSettingForm = this.formBuilder.group({
      vendorNameFormat: [1],
      vendorCaseFormat: [55],
      defaultProductDisplay: [false],
      product: [{ value: '0', disabled: true }],
      enableWebInquiry: [0],
      closeOutVendorId: [''],
      closeOutVendorAlphaNumericId: [''],
      closeOutVendorName: [''],
      closeOutProductId: [0]
    })

    this.subscriptions.push(
      this.vendorSettingForm.get('defaultProductDisplay') ?.valueChanges.subscribe((isChecked) => {
        const productControl = this.vendorSettingForm.get('product');

        if (!productControl) return;

        if (isChecked) {
          productControl.enable();
        } else {
          productControl.disable();
          productControl.setValue('0');
        }
      })
      );

  }

  VendorFilterOption = {
    All: true,
    Current: false,
    Inactive: false,
    PageModel: {
      pageCount: 1,
      pageSize: 20
    }
  };

  ngOnInit(): void {
    this.loaderIcon = Promise.resolve(true);
    this.getVendorNameFormats();
    this.getVendorCaseFormats();
    this.getProductsByMarket();
    this.getVendorGeneralSettings();
    this.getVendorRentalSettings();
  }

  getVendorNameFormats() {
    this.loaderIcon = Promise.resolve(true);
    const sub = this.vendorSettingService.getVendorNameFormats().subscribe((res: any) => {
      if (res) {
        this.vendorNamingConventions = res;
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  getVendorCaseFormats() {
    this.loaderIcon = Promise.resolve(true);
    const sub = this.generalService.getListOfValuesByType(13).subscribe((response: any) => {
      if (response.length) {
        this.vendorCasingCoventions = response;
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  getProductsByMarket() {
    this.loaderIcon = Promise.resolve(true);
    const sub = this.productService.getProductsByMarket().subscribe((res: any) => {
      if (res) {
        this.marketProductList = res.map((el, i) => ({
          ProductId: el.ProductId,
          ProductDescription: el.ProductName,
        }));
        this.marketProductSelectedList = res.map((el, i) => ({
          ProductID: el.ProductId,
          ProductDescriptions: el.ProductName,
        }));
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  getVendorGeneralSettings() {

    const sub = this.vendorSettingService.getVendorGeneralSettings().subscribe((res: any) => {
      if (res) {
        this.vendorSettingForm.get('defaultProductDisplay') ?.setValue(res.DefaultProductSelected);
        this.vendorSettingForm.get('product') ?.setValue(res.ProductId);
        this.vendorSettingForm.get('vendorCaseFormat') ?.setValue(res.VendorNamingCaseId);
        this.vendorSettingForm.get('vendorNameFormat') ?.setValue(res.VendorNamingConventionId);
        this.vendorSettingForm.get('enableWebInquiry') ?.setValue(res.EnableWebInquiry);
      }
      this.vendorSettingForm.markAsPristine();
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });

    this.subscriptions.push(sub);
  }

  getVendorRentalSettings(): void {

    const sub = this.vendorSettingService.getVendorRentalSettings().subscribe((res: any) => {
      if (res) {
        this.vendorSettingForm.get('closeOutVendorId') ?.setValue(res.CloseOutVendorId);
        this.vendorSettingForm.get('closeOutVendorAlphaNumericId') ?.setValue(res.CloseOutVendorAlphaNumericId);
        this.vendorSettingForm.get('closeOutVendorName') ?.setValue(res.CloseOutVendorName);
        this.vendorSettingForm.get('closeOutProductId') ?.setValue(res.CloseOutProductId);
      }
      this.vendorSettingForm.markAsPristine();
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });

    this.subscriptions.push(sub);
  }

  saveVendorGeneralSetting() {
    if (!this.vendorSettingForm.dirty) {
      this.toastr.warning(
        'No changes to save',
        $localize`Warning`,
        this.sharedHTMLSettings.ToasterConfig
      );
      return;
    }
  
    const defaultProductChecked = this.vendorSettingForm.get('defaultProductDisplay')?.value;
  const selectedProduct = this.vendorSettingForm.get('product')?.value;

  if (defaultProductChecked && (selectedProduct === '0' || selectedProduct === 0)) {
    this.toastr.warning(
      'Please select a valid product before saving.',
      $localize`Validation`,
      this.sharedHTMLSettings.ToasterConfig
    );
    return; 
  }

    this.loaderIcon = Promise.resolve(true);
    const obj = {
      DefaultProductSelected: this.vendorSettingForm.get('defaultProductDisplay') ?.value,
      ProductId: this.vendorSettingForm.get('product') ?.value,
      VendorNamingCaseId: this.vendorSettingForm.get('vendorCaseFormat') ?.value,
      VendorNamingConventionId: this.vendorSettingForm.get('vendorNameFormat') ?.value,
      EnableWebInquiry: this.vendorSettingForm.get('enableWebInquiry') ?.value,
    };
    const fieldName = this.wordReplacePipe.transform('Vendor');
    const sub = this.vendorSettingService.saveVendorGeneralSetting(obj).subscribe({
      next: (res: any) => {
        if (res.Success) {
          this.toastr.success(`${fieldName} settings saved successfully`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
        } else {
          this.toastr.error(`Error occurred while saving the ${fieldName} settings`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
        }
        this.saveVendorRentalSetting();

        this.vendorSettingForm.markAsPristine();
        this.loaderIcon = Promise.resolve(false);
      },
      error: () => {
        this.toastr.error(`Error occurred while saving the ${fieldName} settings`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
        this.loaderIcon = Promise.resolve(false);
      }
    });
    this.subscriptions.push(sub);
  }

  saveVendorRentalSetting(): void {
    const data = this.vendorSettingForm.value;
    data.closeOutVendorId = this.vendorSettingForm.get('closeOutVendorId') ?.value;
    const sub = this.vendorSettingService.saveVendorRentalSetting(data).subscribe(res => {
      this.getVendorGeneralSettings();
      this.getVendorRentalSettings();
    });
    this.subscriptions.push(sub);
  }

  routeBack() {
    if (this.vendorSettingForm.dirty) {
      Swal.fire({
        title: $localize`Confirm`,
        text: $localize`Unsaved changes will be lost. Are you sure you want to continue?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.router.navigate(['/dashboard']);
        }
      });
    } else {
      this.router.navigate(['/dashboard']);
    }
  }

  openVendorModal() {
    document.querySelectorAll('.modal-backdrop').forEach(e => e.remove());
    const vendorModal = new bootstrap.Modal(
      document.getElementById('vendorSearchModal')!,
      {
        backdrop: 'static',
        keyboard: false,
        focus: true
      }
    );
    vendorModal.show();
  }

  private showWarning(message: string) {
    Swal.fire({
      title: $localize`Warning`,
      text: message,
      icon: "warning",
      confirmButtonText: $localize`Ok`,
    });
  }

  getVendorById(): void {
    const vendorId = this.vendorSettingForm.get('closeOutVendorAlphaNumericId') ?.value;

    if (!vendorId) {
      this.vendorSettingForm.patchValue({ closeOutVendorName: '', closeOutVendorId: '' });
      return;
    }

    this.subscriptions.push(
      this.vendorService.getVendorInfoByMarketVendorId(vendorId)
        .pipe(take(1))
        .subscribe((res) => {
          if (res ?.VendorId) {
            this.vendorSettingForm.patchValue({
              closeOutVendorId: res.VendorId,
              closeOutVendorName: res.VendorName,
            });
          }
          else {
            this.vendorSettingForm.patchValue({
              closeOutVendorId: '',
              closeOutVendorName: '',
            });
            this.showWarning($localize`Vendor ID does not exist.`);
          }
        })
    );
  }

  onVendorSelected(vendor: any) {
    this.vendorSettingForm.patchValue({
      closeOutVendorAlphaNumericId: vendor.marketVendorId,
      closeOutVendorId: vendor.vendorId,
      closeOutVendorName: vendor.vendorName
    });
    this.vendorSettingForm.markAsDirty();
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
}
